import { Component, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConfirmModalService } from '@core/services';

@Component({
  moduleId: module.id,
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.less']
})
export class ConfirmModalComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('confirmModalDialogContainer') confirmModalDialogContainer: ElementRef

  // designed to be JQuery free
  public visible = false;
  public visibleAnimate = false;
  public header: string;
  public subHeader: string;
  public message: string;
  public btn1Text: string;
  public btn2Text: string;
  public cancelText: string;
  private btn1Emit: string;
  private btn2Emit: string;
  private cancelEmit: string;
  private customBackdrop = false;
  private subscriptions = new Subscription();
  constructor(
    private modalService: ConfirmModalService,
    private cdr: ChangeDetectorRef,
  ) {
    this.resetText();
  }

  resetText() {
    this.header = '';
    this.subHeader = '';
    this.message = '';
    this.btn1Text = '';
    this.btn2Text = '';
    this.cancelText = '';
  }

  ngOnInit() {

  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    this.modalService.setModal(this);
    setTimeout(() => {
      this.confirmModalDialogContainer.nativeElement.focus();
      this.confirmModalDialogContainer.nativeElement.click();
    }, 200);
  }

  public setHeader(header: string) {
    this.header = header;
  }

  public setSubHeader(header: string) {
    this.subHeader = header;
  }

  public setMessage(message: string) {
    this.message = message;
  }

  public setBtn1Text(text: string) {
    this.btn1Text = text;
  }

  public setBtn2Text(text: string) {
    this.btn2Text = text;
  }

  public setCancelText(text: string) {
    this.cancelText = text;
  }

  public show(
    header: string,
    subHeader: string,
    message: string,
    btn1Text: string,
    btn2Text: string,
    cancelText: string,
    hidePrevious: boolean = true,
    btn1Emit: string = 'btn1',
    btn2Emit: string = 'btn2',
    cancelEmit: string = 'close',
  ) {
    this.header = header;
    this.subHeader = subHeader;
    this.message = message;
    this.btn1Text = btn1Text;
    this.btn2Text = btn2Text;
    this.cancelText = cancelText;
    this.btn1Emit = btn1Emit;
    this.btn2Emit = btn2Emit;
    this.cancelEmit = cancelEmit;
    this.showPreset(hidePrevious);
  }

  public showPreset(hidePrevious: boolean = true) {
    // make sure the dialog has been properly set or don't show it.
    if ((this.header || this.subHeader || this.message) && (this.btn1Text || this.cancelText)) {
      if (this.visible) {
        if (hidePrevious) {
          this.modalService.hideModal();
          setTimeout(() => {
            this.visible = true;
            setTimeout(() => { this.visibleAnimate = true; this.cdr.detectChanges(); }, 100);
          }, 700);
        } else {
          this.visible = true;
          setTimeout(() => { this.visibleAnimate = true; this.cdr.detectChanges(); }, 100);
        }
      } else {
        this.visible = true;
        setTimeout(() => { this.visibleAnimate = true; this.cdr.detectChanges(); }, 100);
      }
    }
  }

  onBtn1Click() {
    this.modalService.hideModal();
    this.modalService.onBtnEvent(this.btn1Emit);
  }

  onBtn2Click() {
    this.modalService.hideModal();
    this.modalService.onBtnEvent(this.btn2Emit);
  }

  onClose() {
    this.modalService.hideModal();
    this.modalService.onBtnEvent(this.cancelEmit);
  }

  public hide() {
    setTimeout(() => {
      this.visibleAnimate = false;
      this.cdr.detectChanges();
      setTimeout(() => { this.visible = false; this.resetText(); this.cdr.detectChanges(); }, 300);
    }, 300);
  }

  public onContainerClicked(event: MouseEvent) {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      // this is currently pulled to make modals always open unless the close
      // button is hit or the internal form submits. Otherwise an off-click
      // would close the modal if the command below is enabled.
      this.subscriptions.add(this.modalService.ordCommingSoon.subscribe(commingSoon => {
        if (commingSoon === 'executed') {
          this.customBackdrop = true;
        } else {
          this.customBackdrop = false;
        }
      }));
      if (this.customBackdrop) {
        this.modalService.findOrderCommingSoon('');
        this.onClose();
      }

    }
  }
  public onKeyPressed(event: KeyboardEvent) {
    if(event.code && event.code?.toLowerCase() == 'escape') {
      this.onClose();
    }
  }
}
